module.exports = __webpack_public_path__ + "static/media/1_pl.451b7e79.png";